import { formatAmount } from '@/util/helpers'

export default function () {
  return {
    formatAmount,
    dateBeforePicker: false,
    dateAfterPicker: false,
    filters: {
      'date[before]': '',
      'date[after]': '',
      status: '',
    },
    reports: [],
    chart: {
      options: {
        chart: {
          id: 'orders',
        },
        xaxis: {
          categories: [],
        },
        yaxis: {
          labels: {
            formatter: (value) => {
              return value.toFixed(1)
            },
          },
        },
      },
      series: [{
        name: 'Compras',
        data: [],
      }],
    },
  }
}
